<template>
	<div class="news-view">
		<div class="category" :style="{ 'background-color': categoryColor }"><span>{{ categoryName }}</span></div>

		<div class="news-view-contents">
			<div class="news-header horizontal-center">
				<common-avatar :width="30" :name="staffName" :staffId="staffId" :image="staffAvatar"></common-avatar>
				<span class="name">{{ staffName }}</span>
				<div class="space"></div>
				<span class="created">{{ created }}</span>
			</div>

			<div class="sv-title mt-10 mb-5">{{ title }}</div>
				
			<div class="news-body">
				<div class="word-wrap">{{ body }}</div>
				<div style="text-align: center;" v-for="(row, index) in images" :key="index">
					<preview class="mt-10" :image="row" :maxH="180"></preview>
				</div>
			</div>

			<like class="mt-20" :count="likeCount" :isLiked="isLiked" @click="onLikeClick"></like>

			<textarea class="sv-textarea mt-20 mb-20" v-model="comment" placeholder="このニュースにコメントしよう！" rows="1"></textarea>

			<b-button type="is-primary" class="button-center" rounded @click="onCommentClick" :loading="isCommentLoading" :disabled="isCommentDisabled">送信する</b-button>

			<hr class="mt-20 mb-20"/>

			<div v-if="comments.length === 0">コメントはまだありません</div>

			<div class="comment-wrap" v-for="(row, index) in comments" :key="index">
				<div class="comment-header horizontal-center">
					<common-avatar :width="30" :name="row.staff.name" :staffId="row.staff.id" :image="row.staff.avatar"></common-avatar>
					<span class="name">{{ row.staff.name }}</span>
				</div>

				<div class="word-wrap mt-20 mb-10">{{ row.body }}</div>

				<div class="comment-footer" style="text-align: right;">
					<span class="created">{{ row.created }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.news-view {
	background: #fff;

	.news-view-contents {
		padding: 15px;

		.name {
			font-size: 18px;
			font-weight: $extraBold;
			margin-left: 15px;
		}
	}

	.comment-wrap:not(first-child) {
		margin-top: 20px;
	}
}

@media screen and (min-width: $breakPoint) {
	.news-view {
		margin-left: 200px;
		margin-right: 200px;

		.news-view-contents {
			padding: 60px 80px;

			/deep/ .avatar {
				img {
					width: 90px !important;
				}
			}

			/deep/ .sv-preview {
				img {
					max-height: 100% !important;
				}
			}
		}
	}
}

</style>

<script>
import CommonAvatar from '@/components/CommonAvatar'
import Preview from '@/components/Preview'
import Like from '@/components/Like'

export default {
	name: 'NewsView',
	components: {
		CommonAvatar,
		Preview,
		Like,
	},
	data () {
		return {
			id: '',
			title: '',
			body: '',
			categoryColor: '',
			categoryName: '',
			comments: [],
			created: '',
			likeCount: 0,
			staffName: '',
			staffId: '',
			staffAvatar: '',
			images: [],
			comment: '',
			isCommentLoading: false,
			isLiked: false,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	computed: {
		categoryStyle: function() {
			return this.category ? { 'background-color': this.category.color } : '';
		},
		isCommentDisabled: function() {
			return this.comment === '';
		}
	},
	methods: {
		onCommentClick: async function() {
			this.isCommentLoading = true;
			let ep = 'news-comments';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { 'news_id': this.id, 'body': this.comment }, true);
				this.$utils.log(res);
				this.comment = '';
				this.comments = res.data.comments;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isCommentLoading = false;
			}
		},
		onLikeClick: async function() {
			let ep = 'news-likes';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { 'news_id': this.id }, true);
				this.$utils.log(res);
				this.getData(false);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function(isLoading = true) {
			let loader;
			if (isLoading) {
				loader = this.$buefy.loading.open();
			}
			let ep = 'news/' + this.$route.params.newsId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.title = res.data.title;
				this.body = res.data.body;
				this.categoryColor = res.data.category.color;
				this.categoryName = res.data.category.name;
				this.comments = res.data.comments;
				this.created = res.data.created;
				this.likeCount = res.data.like_count;
				this.isLiked = res.data.is_liked;
				this.staffName = res.data.staff.name;
				this.staffId = res.data.staff.id;
				this.staffAvatar = res.data.staff.avatar;
				this.images = res.data.images;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				if (isLoading) {
					loader.close();
				}
			}
		},
	}
}
</script>
